import { PROFILES } from "./data";
import type { Profile } from "./types";

// The "logged-in" user for the static prototype.
export const CURRENT_USER: Profile = PROFILES[0];
